import {memo} from 'react'

import {ProjectListRow} from './ProjectListRow'
import {ProjectRowActionMenu} from './ProjectRowActionMenu'
import type {Project} from './types'

interface ProjectRowProps {
  project: Project
  onCopyProject: (project: Project) => void
  onCopyAsTemplate: (project: Project) => void
  onUnlinkProject: (project: Project) => void
}

function ProjectRowComponent({project, onCopyProject, onCopyAsTemplate, onUnlinkProject}: ProjectRowProps) {
  // Render the kebab whenever the viewer has at least one actionable item.
  const hasMenuItem = project.viewerCanWrite || project.viewerCanCopy || project.viewerCanCopyAsTemplate

  return (
    <ProjectListRow
      project={project}
      secondaryActions={
        hasMenuItem ? (
          <ProjectRowActionMenu
            project={project}
            onCopyProject={onCopyProject}
            onCopyAsTemplate={onCopyAsTemplate}
            onUnlinkProject={onUnlinkProject}
          />
        ) : undefined
      }
    />
  )
}

export const ProjectRow = memo(ProjectRowComponent)
